export interface FilterParams {
  offset: number;
  limit: number;
}
export enum BrandsEnum {
  VALIO = 'valio',
  FINNY = 'finny',
}

export enum VisibleEnum {
  YES = 'yes',
  NO = 'no',
}
